/* Later you'll simply have
<WaiverContentSectionSidebar
    sections={sections}
    activeIndex={activeIndex}
    onSectionChange={handleSectionChange}
/>
*/

import { Lock, Pencil } from "lucide-react";
import { normalizeHtmlEntities } from "../../../../api/helpers";

const WaiverContentSectionSidebar = ({
    sections,
    activeIndex,
    onSectionChange,
}) => {

    return (

        <div className="w-72 bg-white rounded-xl shadow-sm p-4">

            <div className="font-semibold mb-4">
                Waiver Sections
            </div>

            {sections.map((section, index) => {

                if (!section) return null;

                const locked = section.status === "locked";

                return (

                    <button
                        key={section._id || index}
                        type="button"
                        onClick={() => onSectionChange(index)}
                        className={`
                            w-full
                            flex
                            items-center
                            justify-between
                            px-4
                            py-3
                            rounded-lg
                            mb-2
                            transition-colors

                            ${
                                activeIndex === index
                                    ? "bg-black text-white"
                                    : "hover:bg-gray-100"
                            }
                        `}
                    >

                        <span className="text-sm text-left">

                            {normalizeHtmlEntities(section.title)}

                        </span>

                        {locked ? (
                            <Lock size={14} />
                        ) : (
                            <Pencil size={14} />
                        )}

                    </button>

                );

            })}

        </div>

    );

};

export default WaiverContentSectionSidebar;